import { useQuery } from "@tanstack/react-query";
import CommonService from "../services/CommonService";

export const useContainerLoadTypes = () => {
    return useQuery({
        queryKey: ["containerLoadTypes"],
        queryFn: () => CommonService.getAllContainerLoadTypes().then(res => res.data),
        staleTime: Infinity,
        cacheTime: Infinity,
        placeholderData: (prevData) => prevData
    });
};